import {
  composeClassNames,
  deepEqual,
  getItem,
  ifDefined,
} from "@faedev/editor-utils";
import Link from "next/link";
import { CSSProperties } from "react";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import constants from "src/constants";
import { sIntroductionInfo } from "src/styles/sIntroductionInfo.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  type: "serie" | "serie-class" | "class" | "instructor" | "stream" | "links";
  data: { item: string | number; url?: string | null | undefined }[];
};

function IntroductionInfo({ style, className, type, data }: Props) {
  var showFirst =
    !constants.Show.instructorLoyalty && deepEqual(type, `instructor`)
      ? false
      : true;
  return ifDefined(
    data,
    (value) =>
      getItem(data, 0) ? (
        <div
          className={composeClassNames([
            sIntroductionInfo,
            className,
            type,
            "introduction-info",
          ])}
          style={style}
        >
          {ifDefined(
            getItem(data, 0),
            (value) =>
              (function () {
                const url = typeof data[0].url === "string" ? data[0].url : "";
                switch (type) {
                  case `serie`:
                    return (
                      <Text size="xm">
                        <Link href={url}>
                          <a>{data[0].item}</a>
                        </Link>
                      </Text>
                    );
                  case `serie-class`:
                    return (
                      <Text size="xm">
                        <Link href={url}>
                          <a>{data[0].item}</a>
                        </Link>
                      </Text>
                    );
                  case `class`:
                    return (
                      <Text size="xm">
                        <Link href={url}>
                          <a>{data[0].item}</a>
                        </Link>
                      </Text>
                    );
                  case `instructor`:
                    return constants.Show.instructorLoyalty ? (
                      <Text size="xm">{data[0].item}</Text>
                    ) : null;
                  case `stream`:
                    return (
                      <Text size="xm">
                        <Link href={url}>
                          <a>{data[0].item}</a>
                        </Link>
                      </Text>
                    );
                  case `links`:
                    return (
                      <Text size="xm">
                        <Link href={url}>
                          <a>{data[0].item}</a>
                        </Link>
                      </Text>
                    );
                }
              })(),
            () => null
          )}
          {ifDefined(
            getItem(data, 1),
            (value) => (
              <>
                {showFirst ? <div className={"point"}>{`•`}</div> : null}
                {(function () {
                  switch (type) {
                    case `serie`:
                      return data[1].item > 0 ? (
                        <Text size="xm">
                          {String(data[1].item) + ` `}
                          <Translate tKey={`classes`} />
                        </Text>
                      ) : null;
                    case `serie-class`:
                      return (
                        <Text size="xm">
                          <Link href={data[1].url}>
                            <a>{data[1].item}</a>
                          </Link>
                        </Text>
                      );
                    case `class`:
                      return data[1].item > 0 ? (
                        <Text size="xm">
                          {data[1].item < 1000 ? (
                            <>
                              {String(data[1].item) + ` `}
                              <Translate tKey={`views`} />
                            </>
                          ) : (
                            <>
                              {String(
                                Math.round(Number(data[1].item) / 100) / 10
                              ) + ` `}
                              <Translate tKey={`k views`} />
                            </>
                          )}
                        </Text>
                      ) : null;
                    case `instructor`:
                      return <Text size="xm">{data[1].item}</Text>;
                    case `stream`:
                      return null;
                    case `links`:
                      return (
                        <Text size="xm">
                          <Link href={data[1].url}>
                            <a>{data[1].item}</a>
                          </Link>
                        </Text>
                      );
                  }
                })()}
              </>
            ),
            () => null
          )}
          {ifDefined(
            getItem(data, 2),
            (value) => (
              <>
                {data[2].item > 0 || String(data[2].item).length > 1 ? (
                  <div className={"point"}>{`•`}</div>
                ) : null}
                {(function () {
                  switch (type) {
                    case `serie`:
                      return data[2].item > 0 ? (
                        <Text size="xm">
                          {String(data[2].item) + ` `}
                          <Translate tKey={`k views`} />
                        </Text>
                      ) : null;
                    case `serie-class`:
                      return data[2].item > 0 ? (
                        <Text size="xm">
                          {String(data[2].item) + ` `}
                          <Translate tKey={`k views`} />
                        </Text>
                      ) : null;
                    case `class`:
                      return null;
                    case `instructor`:
                      return data[2].item > 0 ? (
                        <Text size="xm">
                          {String(data[2].item) + ` `}
                          <Translate tKey={`followers`} />
                        </Text>
                      ) : null;
                    case `stream`:
                      return null;
                    case `links`:
                      return (
                        <Text size="xm">
                          <Link href={data[2].url}>{data[2].item}</Link>
                        </Text>
                      );
                  }
                })()}
              </>
            ),
            () => null
          )}
        </div>
      ) : null,
    () => null
  );
}

export default IntroductionInfo;
